import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { IGKMaalingAvLufthastighetIRommetResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import { Box, Paper, Stack, Title } from "@mantine/core";
const MaalingAvLufthastighetIRommet: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvLufthastighetIRommetResultater;
}> = ({ data, onUpdateEditData }) => {
  const updateMaaleresultater = (resultat, i) => {
    const maaleresultater = [...data.inndata.maaleresultater];
    maaleresultater[i] = resultat;
    onUpdateEditData("testResultater.maalingAvLufthastighetIRommet.inndata.maaleresultater", maaleresultater);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Måling av lufthastighet i rommet
        </Title>
        <Stack gap={0}>
          <b>Fyll inn måleresultater &#40;m/s&#41;:</b>
          {data.inndata.maaleresultater.map((a, i) => (
            <McInputNew
              style={{ marginBottom: "0.25rem", width: "25%" }}
              key={i}
              value={a}
              normalizeNumbers={true}
              type="text"
              onBlur={(e) => updateMaaleresultater(Number(e.target.value), i)}
            />
          ))}
        </Stack>
        <Box mt="sm" w="50%">
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) =>
              onUpdateEditData("testResultater.maalingAvLufthastighetIRommet.inndata.kommentar", e.target.value)
            }
          />
        </Box>
      </Stack>
    </Paper>
  );
};
export default MaalingAvLufthastighetIRommet;
